import { useQuery } from "react-query";
import AttributeDataService from "../../services/attribute-data-service/AttributeDataService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";
import { IAttributeSchemaModel } from "../../services/attribute-data-service/Models";

export type UseAttributesSchemasParameters = {
    organizationID: number,
    groupID: number,
} & BaseUseQueryParameters<IAttributeSchemaModel[]>;

export function useAttributeSchemas({
    organizationID,
    groupID,
    enabled,
    onError,
    onSuccess,
}: UseAttributesSchemasParameters) {
    return useQuery<IAttributeSchemaModel[], RestError>(
        keys.attributeSchemas(organizationID, groupID),
        ({ signal }) => {
            return AttributeDataService.getAttributeSchemas(
                organizationID,
                groupID, 
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: false,
            //staleTime: Infinity
            staleTime: 0,
            //refetchOnMount: 'always'
            refetchOnWindowFocus: false

        }
    );
}